const players = [1, 2, 3]

const lines = [2, 3]

const stepsCount = 10;

const statuses = {
  inPlay: 0,
  won: 1,
  lost: 2,
}

const getModelByGameSettings = linesCount => {
  let result = [];
  for (let i = 0; i < stepsCount; i++) {
    result[i] = [];
    for (let t = 0; t < linesCount; t++) {
      result[i][t] = { stepId: i, glassId: t };
    }
  }
  return result;
}

const getWinnings = (m, p, rtp, amount, coeffs) => {
  const result = [];
  for (let i = 0; i < stepsCount; i++) {
    const newValue = coeffs?.[m]?.[p]?.[i] * rtp;
    result[i] = (newValue * amount).toFixed(i <= 5 ? 3 : 2)
  }
  return result;
}

export { players, lines, getModelByGameSettings, stepsCount, getWinnings, statuses };